class Files {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/files`;
    this.apiClient = apiClient;

  }

  async setFileParentEntityDetails(fileIds, parentEntityType, parentEntityId) {

    const path = `${this.basePath}/parent-entity`;

    return this.apiClient.put(path, {}, {}, { fileIds, parentEntityType, parentEntityId });

  }

  async uploadNewConversationImage(file) {

    const path = `${this.basePath}/new-conversation-image`;

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

  async uploadNewConversationVideo(file) {

    const path = `${this.basePath}/new-conversation-video`;

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

  async uploadNewConversationAudio(file) {

    const path = `${this.basePath}/new-conversation-audio`;

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

  async uploadCSVFile(file) {

    const path = `${this.basePath}/csv`;

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

}

export default Files;